import { BadRequestError } from '@/errors/custom'
import { ZodType } from 'zod'
import { formatZodError } from './zodErrorFormatter'

/**
 * Parses and validates data against a Zod schema.
 * Throws a BadRequestError if validation fails.
 *
 * @param {unknown} data - The data to validate.
 * @param {ZodType<T>} schema - The Zod schema to validate against.
 * @returns {T} - The validated data.
 * @throws {BadRequestError} - If the data does not match the schema.
 */
export function parseOrThrow<T>(data: unknown, schema: ZodType<T>): T {
  const result = schema.safeParse(data)
  if (!result.success) {
    throw new BadRequestError(formatZodError(result.error))
  }
  return result.data
}
